import get from 'lodash/get'
import ApiProcessor from '../../processors/api-processor'

import store from '~/state/store'

const TABLE_FILTERS = [
  {
    attribute: 'name',
    label: 'Category Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'retailersCount',
    label: 'Number of Retailers',
    type: 'numeric',
    icon: 'el-icon-document',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'name',
    label: 'Category Name',
    icon: 'el-icon-document',
    width: 100,
  },
  {
    name: 'retailersCount',
    label: 'Number of Retailers',
    icon: 'el-icon-document',
    format: val => val.toString(),
  },
  {
    name: 'providerId',
    label: 'Provider',
    icon: 'el-icon-document',
    format: (val, row) => {
      const provider = store.getters['providers/provider'](val)
      return get(provider, 'name', '')
    },
  },
]

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'categories',
      initialDataQuery: { pageSize: 25 },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'categories',
  }
}
